import axios from 'axios'
import Cookies from 'js-cookie'
import { Notify } from 'vant';
import store from "@/store/index"

axios.defaults.timeout = 10000

axios.interceptors.request.use(
    (config) => {
        if (Cookies.get('payapp_token')) {
          config.headers.Authorization = Cookies.get('payapp_token')
        }
        return config
    },
    (error) => {
        return Promise.reject(JSON.stringify(error))
    }
)

axios.interceptors.response.use(
    (res) => {
        // 导出结果
        if (res.request.responseType === 'arraybuffer') {
            return res
        }
        if (res.data.repCode === '4002') {
            // token失效跳出登陆
            // window.location.href = '/#/login'
            store.commit("loginOut")
            Notify({
                type: "warning",
                message: res.data.repMsg+"，请前往工作台重新进入"
            })
            return {}
        } else if (res.data.repCode !== '0000') {
            // 0000为成功返回码
            //   Message.error(res.data.repMsg)
            Notify({
                type: "warning",
                message: res.data.repMsg
            })
            return {}
        } else {
            return res.data
        }
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default axios
